import { Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { appLanguage, type AppLanguage } from '../i18n'

export function LanguageSwitcher() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const current = appLanguage()

  function select(language: AppLanguage) {
    const params = new URLSearchParams(location.search)
    if (language === 'en') params.set('lang', 'en')
    else params.set('lang', 'pt-BR')
    navigate({ pathname: location.pathname, search: params.toString() }, { replace: true })
  }

  return (
    <div className="flex items-center gap-1 rounded-full border border-line bg-panel-2 p-1" aria-label={t('language.label')}>
      <Languages size={14} className="ml-1 text-ink-3" aria-hidden="true" />
      {(['pt-BR', 'en'] as const).map((language) => (
        <button
          key={language}
          type="button"
          className={`rounded-full px-2.5 py-1.5 text-[11px] font-semibold transition ${current === language ? 'bg-panel text-ink shadow-sm' : 'text-ink-2 hover:text-ink'}`}
          aria-pressed={current === language}
          aria-label={language === 'pt-BR' ? t('language.portuguese') : t('language.english')}
          title={language === 'pt-BR' ? t('language.portuguese') : t('language.english')}
          onClick={() => select(language)}
        >
          {language === 'pt-BR' ? 'PT' : 'EN'}
        </button>
      ))}
    </div>
  )
}
